export class PaymentStatusModel {
  validPayment: boolean;
  message: string;
  paymentProcessStatus: string;
}
